// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__FJ6VD","toggleWrap":"styles_toggleWrap__B7yIm","content":"styles_content__2a6Ie","selectAreaCode":"styles_selectAreaCode__2PzBc"};